import { ApiClientBase } from "../framework/services/api-client-base";
import { isNullOrWhitespace, isThisLocalhost } from "../framework/utils";
import { AdminSignInService } from "./admin-signin";
import { localhostApi } from "./localhost-api";
import * as $http from 'superagent';

class ApiClientClass extends ApiClientBase {
    constructor() {
        super();

        this.host = isThisLocalhost() ? localhostApi : window.location.origin;
        this.host = this.host + '/api';
    }

    protected acquireToken(): Promise<string> {
        return Promise.resolve('');
    }

    protected preSendRequestAction(req: $http.SuperAgentRequest): void {
        const secret = AdminSignInService.getAdminSecret();
        if(isNullOrWhitespace(secret)) { return; }
        req.set('x-storm-parole', secret);
    }

    protected failedRequestAction(resp: $http.Response): void {
        if(resp.status === 404) {
            AdminSignInService.signOut();
        }
    }
}

export const ApiClient = new ApiClientClass();